"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var moment_1 = tslib_1.__importDefault(require("moment"));
exports.isLessAge110 = function (dateString) {
    return moment_1.default().diff(moment_1.default(dateString, 'DD/MM/YYYY'), 'year') <= 110 ? true : false;
};
//# sourceMappingURL=isLessAge110.js.map